// This file was auto-generated by Fern from our API Definition.
export var SimpleApplicationDataOutput;
(function (SimpleApplicationDataOutput) {
    SimpleApplicationDataOutput.Runtime = {
        Python: "python",
        Typescript: "typescript",
        Javascript: "javascript",
    };
})(SimpleApplicationDataOutput || (SimpleApplicationDataOutput = {}));
